import React from 'react';
import {_GPY,__GPYGet,__GPYPost} from '../../../env.js'
import Display from '../../display/Display.js';

class ScoreboardDisplayPanel extends  React.Component {

	constructor(props) {
		super(props);
	  this.state = {
			currentLayout: {id:-1},
			layoutsIsLoaded : false,
			layouts : {},
			displayWidth : this.props.displayWidth!==undefined?this.props.displayWidth: window.innerWidth/4,
		};
	}

	onReSize = (e)=>{
		this.setState({displayWidth : this.props.displayWidth!==undefined?this.props.displayWidth: window.innerWidth/4})
	};

	componentDidMount() {
		this.getLayouts();
		window.addEventListener('resize', this.onReSize);
	}

	componentWillUnmount(){
		window.removeEventListener( 'resize',this.onReSize);
	}

	getLayouts(){
    __GPYGet('getLayouts',(res)=>{
      this.setState({
        layoutsIsLoaded: true,
        layouts: res.Layouts.Layout,
        currentLayout: {id:-1},
      });
      if(_GPY.uiStates.currentOverlayLayout !== undefined) {
        this.setCurrentLayout( parseInt(_GPY.uiStates.currentOverlayLayout));
      }
    },(err)=>{
      this.setState({
        layoutsIsLoaded: false,
        currentLayout: {id:-1},
      })
    });
  }

  changeLayout(e){
      var layoutId = parseInt(e.target.value);
      __GPYPost('setUIState',{currentOverlayLayout: layoutId});
      this.setState({overlaysIsLoaded:false, currentOverlayElement : {id:-1}},() => {
          this.setCurrentLayout(layoutId);
      });
  }

  setCurrentLayout(layoutId) {
     if(layoutId === -1) {
          this.setState({currentLayout:{id:-1}});
      }
      this.state.layouts.forEach((t) => {
           console.log(t,layoutId,t.id === layoutId);
           if(t.id === layoutId) {
             this.setState({currentLayout:t});
           }
      });
  	  if(this.props.scoreboard.state.components['__DISPLAY__'] !== undefined) {
  		    this.props.scoreboard.state.components['__DISPLAY__'].getOverlays(layoutId);
  		}
  }


  render () {
    return (
					<div className="row" style={{width:this.state.displayWidth+"px"}}>
				 			<div className="col-9 p-0 border border">
						 			<select className="form-control"  style={{zIndex:100}} onChange={(e)=>this.changeLayout(e)} value={this.state.currentLayout.id}>
						 				<option key="-1" value="-1">default</option>
						 				{this.state.layoutsIsLoaded ? this.state.layouts.map((t) =>
						 					<option key={t.id} value={t.id}>{t.name}</option>
						 				):""}
						 			</select>
				 			</div>
							<div className="col-3 p-0 border border">
				 				<button className="btn btn-outline-dark btn-block" onClick={()=>this.props.scoreboard.reset()}>Reset</button>
				 			</div>

				 			<div className="col-12 p-0" >
				 					<Display onData={(data,key)=>{this.props.scoreboard.onData(key,data);}} width={this.state.displayWidth} height={ Math.round(this.state.displayWidth/1.7777777778) } layoutId={this.state.currentLayout.id} stateName="__DISPLAY__" scoreboard={this.props.scoreboard}/>
				 			</div>
				 </div>
			 )
  }
}
export default ScoreboardDisplayPanel;
